<ng-template #content let-c="close" let-d="dismiss">
  <div class="lna-modal-header">
    <div class="inline">
      <h4 class="modal-title">
        {{ 'components.requestAdditionalNotes.requestTitle' | translate }}
      </h4>
      @if (shouldRenderTooltip) {
        <app-tooltip [marginBottom]="false" text="requestAppAdditionInfoBackoffice" />
      }
    </div>
    <button class="btn-close" (click)="close()" type="button" aria-label="Close"></button>
  </div>
  <div class="lna-modal-body">
    @if (isCrudLoading) {
      <div class="lna-spinner">
        <app-spinner [isLoading]="isCrudLoading"></app-spinner>
      </div>
    }
    <form [formGroup]="form" [ngClass]="{ hidden: isCrudLoading }">
      <div class="lna-row-32 full-width">
        <div class="label-wrapper">
          <label class="form-label lna" for="backofficeText">
            {{ 'components.requestAdditionalNotes.backofficeText' | translate }}
            <span class="required-field">*</span>
          </label>
        </div>
        <div class="textarea-wrapper">
          <textarea
            class="form-control lna"
            id="backofficeText"
            [ngClass]="{ invalid: shouldRenderError('backofficeText') }"
            type="text"
            formControlName="backofficeText"
            name="backofficeText"
            required
            maxlength="{{ maxFieldLength }}"></textarea>
          <p
            class="length"
            [ngClass]="{
              invalid: backofficeText?.value.length > maxFieldLength
            }">
            {{ backofficeText?.value.length }}/{{ maxFieldLength }}
          </p>
        </div>
        @if (getErrorMessage('backofficeText'); as errorMessage) {
          <div class="error-wrapper">
            <small class="error-message">
              {{ errorMessage | translate }}
            </small>
          </div>
        }
      </div>
      <div class="lna-row-32 value-wrapper file-list">
        <app-file-upload
          [isEditMode]="true"
          [existingFiles]="[]"
          [type]="communicationFileType"
          [associatedEntityId]="note?.id || ''"
          [isSubmitting]="isSubmittingFiles"
          [showDescription]="false"
          (uploading)="handleFileRequests($event)" />
      </div>
    </form>
  </div>
  <div class="lna-modal-footer">
    <button class="primary" [disabled]="isCrudLoading" (click)="submit()" type="button">
      {{ 'components.addAppClientNote.request' | translate }}
    </button>
    <button class="secondary" (click)="close()" type="button">
      {{ 'components.addAppClientNote.cancel' | translate }}
    </button>
  </div>
</ng-template>
